module.exports = __webpack_public_path__ + "img/zdd_invite_jx_3.00bdf49c.png";